import { render, staticRenderFns } from "./TempText.vue?vue&type=template&id=2000466a"
import script from "./TempText.vue?vue&type=script&lang=js"
export * from "./TempText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports